import { lazy } from 'react'

export default lazy(
    () => 
    import('./OrdersViewB2B') 
)